import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./components/Login";
import { useAuthGate } from "./auth";
import PromptStudio from "./pages/PromptStudio";
import CaseLibrary from "./pages/CaseLibrary";
import RunExperiment from "./pages/RunExperiment";
import RunsStorage from "./pages/RunsStorage";
import RunDetail from "./pages/RunDetail";
import Export from "./pages/Export";

export default function App() {
  const { token, authEnabled, email, login, logout } = useAuthGate();

  // When auth is enabled (REACT_APP_GOOGLE_CLIENT_ID set) and not signed in, show the login screen.
  // In local dev (no client id) this is skipped entirely and the console loads directly.
  if (authEnabled && !token) return <Login onLogin={login} />;

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout email={email} onSignOut={authEnabled ? logout : null} />}>
          <Route index element={<Navigate to="/prompt-studio" replace />} />
          <Route path="/prompt-studio" element={<PromptStudio />} />
          <Route path="/cases" element={<CaseLibrary />} />
          <Route path="/experiment" element={<RunExperiment />} />
          <Route path="/runs" element={<RunsStorage />} />
          <Route path="/runs/:runId" element={<RunDetail />} />
          <Route path="/export" element={<Export />} />
          <Route path="*" element={<Navigate to="/prompt-studio" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
